export default {
    faqs: state => state.faqAll
  }
  